import authService from '@/services/auth.service'
import Vue from 'vue'
import axios from 'axios'
import { SET_TOKEN } from '@/store/actions/auth'
import router from '@/router'
import vuei18n from '@/plugins/vue-i18n'
import { config } from '@/plugins/env.config'

const getLocale = () => {
  return config.theme === 'KONEKSI' ? 'es-DO' : vuei18n.locale
}

export default (vuexStore) => {
  const axiosInstance = axios.create()

  axiosInstance.interceptors.request.use((config) => {
    const accessToken = vuexStore.getters.accessToken
    config.headers.Authorization = `Bearer ${accessToken}`
    config.headers['accept-language'] = getLocale()

    return config
  }, (error) => Promise.reject(error))

  axiosInstance.interceptors.response.use((response) => response,
    async (error) => {
      const originalRequest = error.config
      const response = error.response
      const refreshToken = vuexStore.getters.refreshToken

      if (response?.status !== 401 || originalRequest._retry) {
        return Promise.reject(error)
      }

      if (originalRequest._retry) {
        router.push('/login')
      }

      originalRequest._retry = true

      try {
        const tokenData = await authService.refreshToken(refreshToken)
        const accessToken = tokenData.accessToken
        const tokenType = tokenData.tokenType
        vuexStore.commit(SET_TOKEN, { tokenType, accessToken })

        return axiosInstance(originalRequest)
      } catch (e) {
        router.push('/login')
      }
    })

  Vue.prototype.$http = axiosInstance
}
